import { fs } from '../../Firebase'

export const ACCEPT_CHALLENGE = "ACCEPT_CHALLENGE"

const dAcceptChallenge = data => ({
    type: ACCEPT_CHALLENGE,
    data
})

export const acceptChallenge = data => dispatch => {
    return fs.acceptChallenge(data).then( doc => {
        dispatch(dAcceptChallenge(Object.assign({}, data, {id:doc.id})))
    })
}


// WEBPACK FOOTER //
// ./src/Pages/Challenge/actions.js